import API_ENDPOINTS from 'constants/ApiEndpoints';
import { useAppDispatch } from 'store';
import { saveUserProfileReducer } from 'store/user/userSlice';
import useAxios from 'utils/useAxios';

const useProfileUser = () => {
	const { axiosRequest } = useAxios();
	const dispatch = useAppDispatch();

	/* function to fetch user's profile  */
	const fetchProfileUser = () =>
		axiosRequest({ url: API_ENDPOINTS.PROFILE_USER, method: 'get' })
			.then((response) => {
				dispatch(saveUserProfileReducer(response.data.profile));
			})
			.catch((error) => {
				console.log('error', error);
			});

	/* function to fetch user's profile  */
	const updateProfileUser = (data: {}, setErrors: (fields: { [field: string]: string }) => void) =>
		axiosRequest({ url: API_ENDPOINTS.PROFILE_USER, method: 'patch', data })
			.then((response) => {
				// if update happens successfully, fetch the updated profile
				if (response.status === 204) {
					fetchProfileUser();
				}
			})
			.catch((error) => {
				// if update fails, set the errors
				if (error.response.status === 422) {
					setErrors({
						name: error.response.data.error?.message?.name,
						gender: error.response.data.error?.message?.gender,
						address: error.response.data.error?.message?.address,
						email: error.response.data.error?.message?.email,
						mobile: error.response.data.error?.message?.mobile,
					});
				} else if (error.response.status === 409) {
					if (error.response.data.error.message.includes('email')) {
						setErrors({
							email: error.response.data.error?.message,
						});
					} else if (error.response.data.error.message.includes('mobile')) {
						setErrors({
							mobile: error.response.data.error?.message,
						});
					}
				}
			});

	/* function to delete user's profile  */
	const deleteProfileUser = () =>
		axiosRequest({ url: API_ENDPOINTS.PROFILE_USER, method: 'delete' })
			.then((response) => {
				console.log('🚀 ~ file: useProfileUser.ts ~ line 35 ~ .then ~ response', response);
			})
			.catch((error) => {
				console.log('error', error.response);
			});

	return { fetchProfileUser, updateProfileUser, deleteProfileUser };
};

export default useProfileUser;
